// extracted by mini-css-extract-plugin
module.exports = {"accordionContainer":"accordionContainer_accordionContainer__UcFbS"};